/**
 * Hook to check whether a feature add-on is enabled for the current org.
 *
 * Reads from the user store (organization config -> feature_flags).
 * Super admins always get true.
 *
 * Usage:
 *   const hasWorkOrders = useFeatureFlag("work_orders");
 */

import { useUserStore, UserAccessLevel } from "@/stores/user-store";

export function useFeatureFlag(featureKey: string): boolean {
	const user = useUserStore((s) => s.user);

	if (!user) return false;

	// Super admins always have all features
	const accessLevel =
		user.role?.accessLevel ?? user.role?.access_level ?? 0;
	if (accessLevel >= UserAccessLevel.SUPER_ADMIN) return true;

	// Check organization config feature_flags
	const config = user.organization?.config;
	if (!config) return false;

	// feature_flags may be on config as snake_case or camelCase
	const flags: Record<string, boolean> =
		(config as any).feature_flags ??
		(config as any).featureFlags ??
		{};

	return flags[featureKey] === true;
}
